import { OrganizationState } from '../enums/organization-state.enum';
import { CPMMActivationDetails } from '../interfaces/cpmm-activation-details.interface';
import { ILogo } from '../interfaces/logo.interface';
import { OrganizationSettings } from '../interfaces/organization-settings.interface';
import { CreateOrUpdateLicencePackageDto } from './CreateLicencePackageDto.interface';
import { FCPActivationDetails } from './fcpActivationDetails.interface';
import { TierDto } from './organizationSearchDto.interface';
import { UsageData } from './usageData.interface';

export interface GetOrganizationDto {
    id: string;
    name: string;
    state: OrganizationState;
    street?: string;
    streetNumber?: string;
    zip?: string;
    city?: string;
    countryISO31661Alpha2Code?: string;
    additionToAddress?: string;
    logo?: ILogo;
    settings: OrganizationSettings;
    reportingTemplateId?: string | null;
    fcpActivationDetails?: FCPActivationDetails;
    cpmmActivationDetails?: CPMMActivationDetails;
    isMandateAndTaskManagementEnabled?: boolean;
    /** REV-21518 — ABCP-Navigation-Preview org feature flag. null/absent = off (= /cpmm); true =
     *  opted-in → the cpmm→abcp redirect guard sends this org's users to /abcp. See ADR 0002. */
    abcpPreview?: boolean;
    usageData?: UsageData | null;
    licenceData: CreateOrUpdateLicencePackageDto[];
    tier: TierDto
}
